import React from "react";
import "./FileExplorer.scss";
import { FaFileDownload, FaFolderOpen } from "react-icons/fa";
import { Ripple } from "primereact/ripple";
import { FaJava } from "react-icons/fa";
import { TbSql } from "react-icons/tb";
import { FaFileAlt } from "react-icons/fa";
import { CiFileOn } from "react-icons/ci";

export default function FileExplorer({
  activeFile,
  fileStructure,
  handleActiveFile,
}: {
  activeFile: string;
  fileStructure: any[];
  handleActiveFile: any;
}) {
  const renderIcon = (fileName: string) => {
    const lang = fileName.split(".")[1];
    switch (lang) {
      case "java":
        return <FaJava />;
      case "sql":
        return <TbSql />;
      case "zip":
        return <FaFileDownload />;
      case "md":
      case "feature":
        return <FaFileAlt />;
      default:
        return <CiFileOn />;
    }
  };

  const returnFiles = (data: any[]) => {
    return data.map((item, i) => {
      return (
        <div key={i} className="folder">
          {item.files ? (
            <p>
              <FaFolderOpen />
              {item.fileName}
              <Ripple />
            </p>
          ) : (
            <p
              className={activeFile === item.path ? "active" : ""}
              onClick={() => handleActiveFile(item.path)}
            >
              {renderIcon(item.fileName)}
              {item.fileName}
              <Ripple />
            </p>
          )}
          {item.files && <>{returnFiles(item.files)}</>}
        </div>
      );
    });
  };

  return <div className="file-explorer">{returnFiles(fileStructure)}</div>;
}
